import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { Icon } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';

interface Props {
  text?: string;
  hideBreakTimes?: boolean;
}

export const ClosedDayIndicator = ({ text, hideBreakTimes }: Props) => {
  const { t } = useTranslation('schedule');
  return (
    <div css={containerStyle(hideBreakTimes)}>
      <Icon name='moon-small' />
      <Text>{text || t('Closed')}</Text>
    </div>
  );
};

const containerStyle = (hideBreakTimes?: boolean) =>
  css({
    background: theme.colors.neutral10,
    width: '100%',
    maxWidth: hideBreakTimes ? 310 : 345,
    height: 40,
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(1),
    gap: theme.spacing(1),
    opacity: 0.25,
    '@container (max-width: 700px)': {
      maxWidth: hideBreakTimes ? 220 : 255,
    },
  });
